import { render, staticRenderFns } from "./BannerHomeBottom.vue?vue&type=template&id=8028bef6&scoped=true"
import script from "./BannerHomeBottom.vue?vue&type=script&lang=js"
export * from "./BannerHomeBottom.vue?vue&type=script&lang=js"
import style0 from "./BannerHomeBottom.vue?vue&type=style&index=0&id=8028bef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8028bef6",
  null
  
)

export default component.exports